/**
 * Spacing scale — 4px base unit.
 * Use as `theme.spacing['2']` in primitives (= 8px).
 *
 * Keys are step indices as strings (`"0"` … `"16"`) — no `$` prefix, because Unistyles
 * maps theme values to CSS custom properties on web and `$` is invalid in CSS identifiers.
 */
export const spacing = {
    "0": 0,
    "1": 4,
    "2": 8,
    "3": 12,
    "4": 16,
    "5": 20,
    "6": 24,
    "8": 32,
    "10": 40,
    "12": 48,
    "16": 64,
} as const

export type SpacingKey = keyof typeof spacing
